<template>
  <eg-form-group
    :required="required"
    info="This helps our AI tailor the feedback provided to your students' reading levels."
  >
    <div :class="horizontal ? 'd-flex flex-wrap flex-gap-1' : 'd-block'">
      <ToggleButton
        v-for="radioOption in radioOptions"
        :key="radioOption.value"
        :class="horizontal && 'btn d-flex align-center'"
        :horizontal="true"
        :value="radioOption.value"
        :label="$t(radioOption.translationKey)"
        :pressed="value === radioOption.value"
        @click="handleChange(radioOption.value)"
      >
        <span :style="{ color: radioOption.color, fontSize: '11px' }">
          <eg-b-icon :icon="radioOption.icon" />
        </span>
      </ToggleButton>
    </div>
  </eg-form-group>
</template>

<script>
import ToggleButton from "@/components/global/eg_toggle_button.vue";
import EgFormGroup from "@/components/global/eg_form_group.vue";
import { GRADE_LEVELS } from "@/constants";

export default {
  components: { ToggleButton, EgFormGroup },
  props: {
    value: {
      type: String,
      default: "middleschool",
    },
    horizontal: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      radioOptions: GRADE_LEVELS,
    };
  },
  methods: {
    handleChange(valueId) {
      this.$emit("input", valueId);
    },
  },
};
</script>
